module.exports = __webpack_public_path__ + "img/a11y-stability-2_cn.8175512.jpg";